import styled from 'styled-components';

import { POSITION_TOP } from 'global/constants';
import { rem } from 'approot/shared/style';
import { grey1 } from 'approot/shared/styles/colours.style';
import { spacing4 } from 'approot/shared/styles/spacing.style';
import { baseFlexCss } from 'approot/shared/styles/flex.style';
import {
  borderRadius8,
  standardFocusState,
} from 'approot/shared/styles/borders.style';

export const MultipleChoiceEditTextImageUpload = styled.div`
  position: absolute;
  left: calc(50% + 4px);
  right: 0;
  bottom: 0;
  top: 0;
  & > div {
    height: 100%;
  }
`;

export const MultipleChoiceEditTextImageButton = styled.button`
  background-color: ${grey1};
  border: none;
  border-radius: ${rem(borderRadius8)};
  width: 100%;
  height: 100%;

  ${standardFocusState}

  &:hover {
    cursor: pointer;
  }
`;

export const MultipleChoiceEditTextImageColumn = styled.div`
  ${baseFlexCss}
  height: 100%;
  width: 50%;
  position: relative;
`;

export const MultipleChoiceEditTextImageImage = styled.div`
  position: absolute;
  left: calc(50% + 4px);
  right: 0;
  bottom: 0;
  top: 0;
`;

type MultipleChoiceEditTextAndImageProps = {
  $imagePosition: string | null;
  $minHeight: number;
};
export const MultipleChoiceEditTextImage = styled.div<MultipleChoiceEditTextAndImageProps>`
  ${baseFlexCss}

  position: relative;
  min-height: ${({ $minHeight }) => rem($minHeight)};
  height: 100%;
  width: 100%;

  ${({ $imagePosition }) =>
    $imagePosition === POSITION_TOP &&
    `
      flex-direction: column;
      gap: ${rem(spacing4)};
      ${MultipleChoiceEditTextImageColumn} {
        height: auto;
        width: 100%;
      }
      ${MultipleChoiceEditTextImageImage} {
        position: relative;
        left: auto;
        flex-grow: 1;
        width: 100%;
      }
  `}
`;
